import SimpleTvFooter from '../components/Footers/simpletv';
import { CONTENT_TYPES } from '../constants/contentTypes';
import PATHS from '../constants/pathRoutes';
const ENV = window.__TBX_ENV__;

function getEnvConfig(currentENV) {
  console.log('enviroment', currentENV);
  if (
    !currentENV.TBX_CLIENT_KEY ||
    !currentENV.TBX_CLOUDPASS_API ||
    !currentENV.TBX_UNITY_API
  ) {
    console.error(
      '>>>>>> Invalid __TBX_ENV__ definition! check env variables build process',
    );
    return null;
  }

  const IDP_CLIENT = currentENV.TBX_IDP_CLIENT || null;
  const IDP_SHORTCODE = currentENV.TBX_IDP_SHORTCODE || null;
  const useCloudhubConfig = !IDP_CLIENT || !IDP_SHORTCODE;

  return {
    client: {
      SUB: currentENV.TBX_CLIENT_KEY,
      CONFIG_URI: currentENV.TBX_EXPERIENCE_CONFIG,
    },
    cloudpass: {
      API_URL: currentENV.TBX_CLOUDPASS_API,
      IDP_CLIENT,
      IDP_SHORTCODE,
      USE_CLOUDHUB_CONFIG: currentENV.TBX_IDP_USE_CLOUDHUB || useCloudhubConfig,
    },
    unity: {
      API_URL: currentENV.TBX_UNITY_API,
    },
    settings: {
      hispanomedios: {
        validateHaveAccess: false,
        showBuySubscriptionButton: false,
        useDirectAccessToAddOns: true,
        hasDirectAccessToAddOns: true,
        hasPrivacyPolicyLink: true,
        hasHelpLink: true,
        hasPayService: true,
        showContentDescription: false,
        hasCustomHelpSlug: false,
        useSSO: false,
        showSocialNetworksInFooter: false,
        hasMobileLanding: false,
        enabledResponsiveWeb: false,
        searchFilters: {
          contentType: `${CONTENT_TYPES.SPORT},${CONTENT_TYPES.BROADCAST},${CONTENT_TYPES.MOVIE},${CONTENT_TYPES.SERIE}`,
        },
        enableUsPrivacy: true,
        enableCustomTags: false,
        showLiveButtonInEPG: false,
        showFullEpisodeTitle: true,
        pathLogo: '/images/logo.svg',
        showStoresInFooter: false,
        useCategoriesFilterInEpg: false,
        showNetworksContent: true,
        useComscore: { enabled: false, clientId: null, gender: 'Variety' },
        showPowered: false,
      },
      tbxgo: {
        validateHaveAccess: false,
        showBuySubscriptionButton: false,
        useDirectAccessToAddOns: false,
        hasDirectAccessToAddOns: false,
        hasPrivacyPolicyLink: true,
        hasHelpLink: true,
        hasPayService: true,
        showContentDescription: false,
        hasCustomHelpSlug: false,
        useSSO: false,
        showSocialNetworksInFooter: false,
        hasMobileLanding: false,
        enabledResponsiveWeb: false,
        searchFilters: {
          contentType: `${CONTENT_TYPES.SPORT},${CONTENT_TYPES.BROADCAST},${CONTENT_TYPES.MOVIE},${CONTENT_TYPES.SERIE}`,
        },
        enableUsPrivacy: false,
        enableCustomTags: false,
        showLiveButtonInEPG: false,
        showFullEpisodeTitle: true,
        pathLogo: '/images/logo.svg',
        showStoresInFooter: false,
        useCategoriesFilterInEpg: false,
        showNetworksContent: true,
        useComscore: { enabled: false, clientId: null, gender: 'Variety' },
        showPowered: false,
      },
      mio: {
        validateHaveAccess: false,
        showBuySubscriptionButton: false,
        useDirectAccessToAddOns: false,
        hasDirectAccessToAddOns: false,
        hasPrivacyPolicyLink: false,
        hasHelpLink: true,
        hasPayService: false,
        showContentDescription: true,
        hasCustomHelpSlug: true,
        useSSO: false,
        showSocialNetworksInFooter: false,
        hasMobileLanding: false,
        enabledResponsiveWeb: false,
        searchFilters: {
          contentType: `${CONTENT_TYPES.SPORT},${CONTENT_TYPES.BROADCAST},${CONTENT_TYPES.MOVIE},${CONTENT_TYPES.SERIE}`,
        },
        enableUsPrivacy: false,
        enableCustomTags: false,
        showLiveButtonInEPG: false,
        showFullEpisodeTitle: true,
        pathLogo: '/images/logo.svg',
        showStoresInFooter: false,
        showNetworksContent: true,
        useComscore: { enabled: false, clientId: null, gender: 'Variety' },
        showPowered: false,
      },
      sportshub: {
        validateHaveAccess: false,
        showBuySubscriptionButton: false,
        useDirectAccessToAddOns: false,
        hasDirectAccessToAddOns: false,
        hasPrivacyPolicyLink: true,
        hasHelpLink: true,
        hasPayService: true,
        showContentDescription: false,
        hasCustomHelpSlug: false,
        useSSO: false,
        showSocialNetworksInFooter: false,
        hasMobileLanding: false,
        enabledResponsiveWeb: false,
        searchFilters: {
          contentType: `${CONTENT_TYPES.SPORT},${CONTENT_TYPES.BROADCAST},${CONTENT_TYPES.MOVIE},${CONTENT_TYPES.SERIE}`,
        },
        enableUsPrivacy: false,
        enableCustomTags: false,
        showLiveButtonInEPG: false,
        showFullEpisodeTitle: true,
        pathLogo: '/images/logo.svg',
        showStoresInFooter: false,
        useCategoriesFilterInEpg: false,
        showNetworksContent: true,
        useComscore: { enabled: false, clientId: null, gender: 'Variety' },
        showPowered: false,
      },
      winsports: {
        validateHaveAccess: true,
        showBuySubscriptionButton: true,
        useDirectAccessToAddOns: false,
        hasDirectAccessToAddOns: false,
        hasPrivacyPolicyLink: true,
        hasHelpLink: false,
        hasPayService: true,
        showContentDescription: false,
        hasCustomHelpSlug: false,
        useSSO: false,
        showSocialNetworksInFooter: true,
        socialLinks: [
          {
            href: 'https://www.facebook.com/WinSportsTv',
            title: 'facebook',
            icon: 'bi-facebook',
          },
          {
            href: 'https://x.com/WinSportsTV',
            title: 'twitter-x',
            icon: 'bi-twitter-x',
          },
          {
            href: 'https://www.instagram.com/winsportstv/',
            title: 'instagram',
            icon: 'bi-instagram',
          },
          {
            href: 'https://www.youtube.com/@winsportstv',
            title: 'youtube',
            icon: 'bi-youtube',
          },
        ],
        hasMobileLanding: false,
        enabledResponsiveWeb: false,
        searchFilters: {
          contentType: `${CONTENT_TYPES.SPORT},${CONTENT_TYPES.BROADCAST},${CONTENT_TYPES.MOVIE},${CONTENT_TYPES.SERIE},${CONTENT_TYPES.EPISODE}`,
        },
        enableUsPrivacy: false,
        hasFrequentQuestions: true,
        hasConsumerProtection: true,
        hasCookiesPolicy: true,
        enableCustomTags: true,
        showLiveButtonInEPG: false,
        showFullEpisodeTitle: true,
        pathLogo: '/images/logo.svg',
        showStoresInFooter: false,
        useCategoriesFilterInEpg: false,
        showNetworksContent: false,
        useComscore: { enabled: false, clientId: null, gender: 'Variety' },
        showPowered: true,
      },
      motorplay: {
        validateHaveAccess: false,
        showBuySubscriptionButton: false,
        useDirectAccessToAddOns: false,
        hasDirectAccessToAddOns: false,
        hasPrivacyPolicyLink: true,
        hasHelpLink: true,
        hasPayService: true,
        showContentDescription: false,
        hasCustomHelpSlug: false,
        useSSO: false,
        showSocialNetworksInFooter: true,
        hasMobileLanding: false,
        enabledResponsiveWeb: false,
        socialLinks: [
          {
            href: 'https://www.facebook.com/motorplaytv',
            title: 'facebook',
            icon: 'bi-facebook',
          },
          {
            href: 'https://x.com/motorplaytv',
            title: 'twitter-x',
            icon: 'bi-twitter-x',
          },
          {
            href: 'https://www.instagram.com/motorplaytv',
            title: 'instagram',
            icon: 'bi-instagram',
          },
          {
            href: 'https://api.whatsapp.com/send/?phone=5491176138604&text&type=phone_number&app_absent=0',
            title: 'whatsapp',
            icon: 'bi-whatsapp',
          },
          {
            href: 'https://youtube.com/@motorplaytv',
            title: 'youtube',
            icon: 'bi-youtube',
          },
          {
            href: 'https://www.tiktok.com/@motorplaytv',
            title: 'tiktok',
            icon: 'bi-tiktok',
          },
        ],
        searchFilters: {
          contentType: `${CONTENT_TYPES.SPORT},${CONTENT_TYPES.BROADCAST},${CONTENT_TYPES.MOVIE},${CONTENT_TYPES.SERIE}`,
        },
        enableUsPrivacy: false,
        enableCustomTags: false,
        showLiveButtonInEPG: false,
        showFullEpisodeTitle: false,
        pathLogo: '/images/logo.svg',
        showStoresInFooter: false,
        useCategoriesFilterInEpg: false,
        showNetworksContent: false,
        useComscore: { enabled: false, clientId: null, gender: 'Variety' },
      },
      rcn: {
        validateHaveAccess: false,
        showBuySubscriptionButton: false,
        useDirectAccessToAddOns: false,
        hasDirectAccessToAddOns: false,
        hasPrivacyPolicyLink: true,
        hasHelpLink: true,
        hasPayService: false,
        showContentDescription: false,
        hasCustomHelpSlug: false,
        useExtendedFooter: true,
        useSSO: true,
        showSocialNetworksInFooter: false,
        hasMobileLanding: false,
        enabledResponsiveWeb: true,
        disabledSectionsResponsiveWeb: ['/envivo', '/senal-en-vivo'],
        searchFilters: {
          contentType: `${CONTENT_TYPES.SPORT},${CONTENT_TYPES.BROADCAST},${CONTENT_TYPES.MOVIE},${CONTENT_TYPES.SERIE}`,
        },
        newsletterLink: 'https://www.canalrcn.com/boletin/',
        socialLinks: [
          {
            href: 'https://www.facebook.com/CanalRCN/',
            title: 'facebook',
            icon: 'bi-facebook',
          },
          {
            href: 'https://x.com/CanalRCN',
            title: 'twitter-x',
            icon: 'bi-twitter-x',
          },
          {
            href: 'https://www.instagram.com/canalrcn/',
            title: 'instagram',
            icon: 'bi-instagram',
          },
          {
            href: 'https://www.tiktok.com/@canalrcn?lang=es',
            title: 'tiktok',
            icon: 'bi-tiktok',
          },
          {
            href: 'https://www.whatsapp.com/channel/0029Va4Xq8N9xVJbLTXCa81D',
            title: 'whatsapp',
            icon: 'bi-whatsapp',
          },
          {
            href: 'https://www.youtube.com/channel/UCSCAJJ1RJ4rfRTVW4gjYTpQ',
            title: 'youtube',
            icon: 'bi-youtube',
          },
        ],
        corporateSection: {
          sectionTitle: 'Portal corporativo',
          links: [
            {
              title: 'Atención al televidente',
              href: 'https://corporativocanalrcn.com/atencion-al-televidente/',
            },
            {
              title: 'Responsabilidad Social',
              href: 'https://www.responsabilidadsocialcanalrcn.com/',
            },
            {
              title: 'Protocolo VBG y Acoso Sexual Laboral',
              href: 'https://www.responsabilidadsocialcanalrcn.com/sites/default/files/informes_de_sostenibilidad/protocolo_vbg_firmado.pdf',
            },
            {
              title: 'Línea Ética',
              href: 'https://corporativocanalrcn.com/linea-etica/',
            },
            {
              title: 'Atención al inversionista',
              href: 'https://corporativocanalrcn.com/atencion-al-inversionista/',
            },
            {
              title: 'Código de autorregulación',
              href: 'https://media.canalrcn.com/politicas/CodigoAutoregulacion.pdf',
            },
            {
              title: 'OBA',
              href: 'https://corporativocanalrcn.com/oba/',
            },
          ],
        },
        ourPortals: {
          sectionTitle: 'Nuestros Portales',
          links: [
            {
              title: 'Canal RCN',
              href: 'https://www.canalrcn.com/',
            },
            {
              title: 'Zona interactiva',
              href: 'https://www.zona-interactiva.canalrcn.com/',
            },
            {
              title: 'Noticias RCN',
              href: 'https://www.noticiasrcn.com/?_gl=1*d0lw4v*_ga*ODA5ODE5OTI3LjE3Mjc4NzQ0NDA.*_ga_L1L2HC84BZ*MTczMzMyMTM5OC43LjEuMTczMzMyMTcwNS42MC4wLjA.',
            },
            {
              title: 'SuperLike',
              href: 'https://www.superlike.com/',
            },
            {
              title: 'Market RCN',
              href: 'https://www.marketrcn.com/',
            },
          ],
        },
        partnerPortals: {
          sectionTitle: 'Portales aliados',
          links: [
            {
              title: 'Canal RCN',
              href: 'https://www.canalrcn.com/',
            },
            {
              title: 'RCN Radio',
              href: 'https://www.rcnradio.com/',
            },
            {
              title: 'Noticias RCN',
              href: 'https://www.noticiasrcn.com/',
            },
            {
              title: 'La FM',
              href: 'https://www.lafm.com.co/',
            },
            {
              title: 'Deportes RCN',
              href: 'https://www.deportesrcn.com/',
            },
            {
              title: 'Alerta',
              href: 'https://www.alertabogota.com/',
            },
            {
              title: 'Superlike',
              href: 'https://www.superlike.com/',
            },
            {
              title: 'La Mega',
              href: 'https://www.lamega.com.co/',
            },
            {
              title: 'El Sol',
              href: 'https://www.elsol.com.co/',
            },
            {
              title: 'La FM Plus',
              href: 'https://lafmplus.com/',
            },
            {
              title: 'Radio 1',
              href: 'https://www.radiouno.com.co/',
            },
            {
              title: 'La República',
              href: 'https://www.larepublica.co/',
            },
            {
              title: 'NTN24',
              href: 'https://www.ntn24.com/',
            },
            {
              title: 'Win',
              href: 'https://www.winsports.co/',
            },
          ],
        },
        enableCustomTags: false,
        showLiveButtonInEPG: false,
        showFullEpisodeTitle: true,
        pathLogo: '/images/logo.svg',
        showStoresInFooter: false,
        useCategoriesFilterInEpg: false,
        showNetworksContent: true,
        useComscore: {
          enabled: true,
          clientId: currentENV.TBX_COMSCORE_CLIENT_ID || null,
          gender: 'Variety',
        },
        showPowered: false,
      },
      simpletv: {
        validateHaveAccess: false,
        showBuySubscriptionButton: false,
        useDirectAccessToAddOns: false,
        hasDirectAccessToAddOns: false,
        hasPrivacyPolicyLink: true,
        hasHelpLink: true,
        hasPayService: false,
        showContentDescription: true,
        hasCustomHelpSlug: false,
        useSSO: false,
        showSocialNetworksInFooter: true,
        socialLinks: [
          {
            href: 'https://www.facebook.com/Simplevenezuela/',
            title: 'facebook',
            icon: 'bi-facebook',
          },
          {
            href: 'https://x.com/Simple_vzla',
            title: 'twitter-x',
            icon: 'bi-twitter-x',
          },
          {
            href: 'https://www.youtube.com/@simple_vzla',
            title: 'youtube',
            icon: 'bi-youtube',
          },
          {
            href: 'https://www.instagram.com/simple_vzla/',
            title: 'instagram',
            icon: 'bi-instagram',
          },
        ],
        hasMobileLanding: false,
        enabledResponsiveWeb: false,
        searchFilters: {
          contentType: `${CONTENT_TYPES.SPORT},${CONTENT_TYPES.BROADCAST},${CONTENT_TYPES.MOVIE},${CONTENT_TYPES.SERIE}`,
        },
        enableUsPrivacy: false,
        hasFrequentQuestions: false,
        hasConsumerProtection: false,
        hasCookiesPolicy: false,
        enableCustomTags: false,
        showLiveButtonInEPG: false,
        showFullEpisodeTitle: true,
        pathLogo: '/images/logo.svg',
        CustomFooter: SimpleTvFooter,
        useCategoriesFilterInEpg: true,
        showNetworksContent: false,
        useComscore: { enabled: false, clientId: null, gender: 'Variety' },
        showPowered: false,
        customMetaTags: {
          default: {
            title: 'Simpleplus - Reproductor web',
            meta: [
              {
                name: 'robots',
                content:
                  'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
              },
              {
                name: 'description',
                content:
                  'Simpleplus es la plataforma de streaming de Simple. Disfruta de contenido exclusivo, deportes, series, películas y mucho más ingresando aquí.',
              },
              {
                property: 'og:locale',
                content: 'es_ES',
              },
              {
                property: 'og:type',
                content: 'website',
              },
              {
                property: 'og:title',
                content: 'Simpleplus - Reproductor web',
              },
              {
                property: 'og:description',
                content:
                  'Simpleplus es la plataforma de streaming de Simple. Disfruta de contenido exclusivo, deportes y mucho más ingresando aquí.',
              },
              {
                property: 'og:url',
                content: 'https://www.plus.simple.com.ve/',
              },
              {
                property: 'og:site_name',
                content: 'Simpleplus',
              },
            ],
            link: [
              {
                rel: 'canonical',
                href: 'https://www.plus.simple.com.ve/',
              },
            ],
          },
          [PATHS.active]: {
            title: 'Simpleplus - Activa tu dispositivo',
            meta: [
              {
                name: 'robots',
                content:
                  'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
              },
              {
                name: 'description',
                content:
                  'Activa Simpleplus en tu dispositivo ingresando aquí. ¡Estás a unos pocos pasos de vivir una experiencia inolvidable de entretenimiento!',
              },
              {
                property: 'og:locale',
                content: 'es_ES',
              },
              {
                property: 'og:type',
                content: 'website',
              },
              {
                property: 'og:title',
                content: 'Simpleplus - Activa tu Smart TV',
              },
              {
                property: 'og:description',
                content:
                  'Activa Simpleplus en tu dispositivo ingresando aquí. ¡Estás a unos pocos pasos de vivir una experiencia inolvidable de entretenimiento!',
              },
              {
                property: 'og:url',
                content: 'https://plus.simple.com.ve/activar',
              },
              {
                property: 'og:site_name',
                content: 'Simpleplus',
              },
            ],
            link: [
              {
                rel: 'canonical',
                href: 'https://plus.simple.com.ve/activar',
              },
            ],
          },
        },
      },
      vnet: {
        validateHaveAccess: false,
        showBuySubscriptionButton: false,
        useDirectAccessToAddOns: false,
        hasDirectAccessToAddOns: false,
        hasPrivacyPolicyLink: true,
        hasHelpLink: true,
        hasPayService: false,
        showContentDescription: false,
        hasCustomHelpSlug: false,
        useSSO: false,
        showSocialNetworksInFooter: true,
        socialLinks: [
          {
            href: 'https://www.facebook.com/profile.php?id=61566969571570',
            title: 'facebook',
            icon: 'bi-facebook',
          },
          {
            href: 'https://x.com/vnet_ve?utm_source=chatgpt.com',
            title: 'twitter-x',
            icon: 'bi-twitter-x',
          },
          {
            href: 'https://www.instagram.com/vnet_ve/',
            title: 'instagram',
            icon: 'bi-instagram',
          },
        ],
        hasMobileLanding: false,
        enabledResponsiveWeb: false,
        searchFilters: {
          contentType: `${CONTENT_TYPES.SPORT},${CONTENT_TYPES.BROADCAST},${CONTENT_TYPES.MOVIE},${CONTENT_TYPES.SERIE}`,
        },
        enableUsPrivacy: false,
        hasFrequentQuestions: false,
        hasConsumerProtection: false,
        hasCookiesPolicy: false,
        enableCustomTags: false,
        showLiveButtonInEPG: false,
        showFullEpisodeTitle: true,
        pathLogo: '/images/logo.png',
        showStoresInFooter: false,
        useCategoriesFilterInEpg: true,
        showNetworksContent: true,
        useComscore: { enabled: false, clientId: null, gender: 'Variety' },
        showPowered: false,
      },
      default: {
        validateHaveAccess: false,
        showBuySubscriptionButton: false,
        useDirectAccessToAddOns: false,
        hasDirectAccessToAddOns: false,
        hasPrivacyPolicyLink: true,
        hasHelpLink: true,
        hasPayService: true,
        showContentDescription: false,
        hasCustomHelpSlug: false,
        useSSO: false,
        showSocialNetworksInFooter: false,
        hasMobileLanding: false,
        enabledResponsiveWeb: false,
        hasFrequentQuestions: false,
        hasConsumerProtection: false,
        hasCookiesPolicy: false,
        searchFilters: {
          contentType: `${CONTENT_TYPES.SPORT},${CONTENT_TYPES.BROADCAST},${CONTENT_TYPES.MOVIE},${CONTENT_TYPES.SERIE}`,
        },
        enableUsPrivacy: false,
        enableCustomTags: false,
        showLiveButtonInEPG: false,
        showFullEpisodeTitle: true,
        pathLogo: '/images/logo.svg',
        showStoresInFooter: false,
        useCategoriesFilterInEpg: false,
        showNetworksContent: true,
        useComscore: { enabled: false, clientId: null, gender: 'Variety' },
        showPowered: false,
      },
    },
  };
}

const CONFIG = getEnvConfig(ENV);

export default CONFIG;
